import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DataGrid,
  Table,
} from '../../../components/index';
import {
  getObject,
  vinculo,
} from '../../../utils/listsSelect';
import Dependente from './Dependente';

class Dependentes extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({
    acaoModal: 'criacao',
    showModal: false,
    errosDependenteSelecionado: null,
    exigenciasDependentes: null,
    dependenteSelecionado: null,
  })

  handleModal = () => {
    let acaoModal;
    switch (this.props.acao) {
      // Caso em analise do medico perito
      case 'emitir-parecer-medico':
        if (this.alterarDependenteMedico(this.state.dependenteSelecionado)) {
          acaoModal = 'pericia-medica';
        } else {
          acaoModal = 'em-analise';
        }
        break;
      // Caso em Analise
      case 'realizar-analise':
        acaoModal = 'em-analise';
        break;
      // Caso em exigencia
      case 'cumprir-exigencia':
        if (this.verificarSeDependenteVeioDoRequest()) {
          acaoModal = 'edicao';
        } else {
          acaoModal = 'criacao';
        }
        break;
      // Em caso de criacao de requerimento
      case 'novo':
        if (this.props.estadoFormulario !== 'criado') {
          acaoModal = 'criacao';
        } else {
          acaoModal = 'em-analise';
        }
        break;
      case 'indeferidos':
        acaoModal = 'indeferidos';
        break;
      default:
        acaoModal = 'em-analise';
    }
    if (this.props.exigencias && !this.props.isFetchExigencias) {
      const exigenciasDependentes = this.props.exigencias
        .filter(exigencia => exigencia.codigoDependente);
      this.setState({
        showModal: !this.state.showModal,
        acaoModal,
        exigenciasDependentes,
      }, () => this.props.checkIsFetchExigencias());
    } else {
      this.setState({ showModal: !this.state.showModal, acaoModal });
    }
  }

  createCustomInsertButton = () => (
    <Button
      className={this.dependentePossuiExigenciaInclusao() ? 'dtp-inverse' : null}
      onClick={this.handleModal}
      hint="Adicionar dependente"
      icon="ico-user-plus"
    />
  );

  addVinculoLabel = (vinculoSelecionado) => {
    const obj = getObject(vinculo, vinculoSelecionado);
    if (obj === undefined || obj === null) {
      return '';
    }
    return obj.label;
  }

  /**
   * Identifica dependentes a ter parecer emitido:
   *  - capacidades: INVALIDO_INCAPAZ, INVALIDO_CAPAZ
   */
  alterarDependenteMedico = (dependenteSelecionado) => {
    if (this.props.acao === 'emitir-parecer-medico') {
      if (dependenteSelecionado.capacidade === 3 || dependenteSelecionado.capacidade === 5) {
        return true;
      }
      return false;
    }
    return false;
  }

  validacaoExigenciaDependente = (exigenciasDependenteSelecionado) => {
    const exigenciasNovas = this.state.exigenciasDependentes.filter(item =>
      (exigenciasDependenteSelecionado.includes(item) ? null : item));
    this.setState({ exigenciasDependentes: exigenciasNovas });
  }

  /**
   * Determina a acao que estara disponivel para cada dependente:
   * - Usuario esta criando um requerimento ou cumprindo exigencias, dependente pode ser alterado;
   * - Usuario esta emitindo parecer, dependente pode ser alterado se tiver a Capacidade adequada;
   * - Em outras situacoes, o dependente pode apenas ser visualizado.
   */
  createActionColumn = (indice, dependente) => {
    let hint;
    let icon;
    if (this.props.estadoFormulario !== 'criado' && (['novo', 'cumprir-exigencia'].includes(this.props.acao) ||
      this.alterarDependenteMedico(dependente))) {
      hint = 'Editar dependente';
      icon = 'ico-pencil';
    } else {
      hint = 'Visualizar Dependente';
      icon = 'ico-user-magnifier';
    }
    return (
      <React.Fragment>
        <Button
          className={(this.dependentePossuiExigencia(indice, dependente)
            || this.alterarDependenteMedico(dependente)) ? 'dtp-inverse' : null}
          hint={hint}
          icon={icon}
          mini
          onClick={() => this.editDependente(indice, dependente)}
        />
        {this.props.estadoFormulario !== 'criado' && ['novo', 'cumprir-exigencia', 'indeferidos'].includes(this.props.acao) ? (
          <Button
            className={this.dependentePossuiExigenciaExclusao(dependente) ? 'dtp-inverse' : null}
            hint="Excluir dependente"
            icon="ico-user-minus"
            mini
            onClick={() => this.deleteDependente(indice, dependente)}
          />
        ) : ''}
      </React.Fragment>
    );
  };

  dependentePossuiExigencia = (indice, dependente) => {
    // Vinicius
    if (['cumprir-exigencia'].includes(this.props.acao)) {
      if (this.props.exigencias) {
        return (this.props.exigencias
          .filter((exigencia) => {
            if (dependente.codigo) {
              return ((exigencia.tipo !== 11)
              && (exigencia.codigoDependente === dependente.codigo));
            }
            return false;
          }).length > 0) ||
          // Vinicius
          // }).length > 0 && this.props.acao !== 'realizar-analise') ||
          (this.props.errosDependentes ? this.props.errosDependentes
            .some(erro => erro.indiceLista === indice) : false);
      }
    }
    return false;
  }

  dependentePossuiExigenciaExclusao = (dependente) => {
    // Vinicius
    if (['cumprir-exigencia'].includes(this.props.acao)) {
      if (this.props.exigencias) {
        return this.props.exigencias
          .filter(exigencia =>
            (exigencia.tipo === 11) &&
          (exigencia.codigoDependente === dependente.codigo)).length > 0 && this.props.acao !== 'realizar-analise';
      }
    }
    return false;
  }

  dependentePossuiExigenciaInclusao = () => {
    // Vinicius
    if (['cumprir-exigencia'].includes(this.props.acao)) {
      if (this.props.exigencias) {
        return this.props.exigencias.filter(exigencia => exigencia.tipo === 10).length > 0;
      }
    }
    return false;
  }

  /**
   * Determina quais colunas devem ser exibidas na tabela de dependentes
   */
  montaDependentesTableHeader = () => {
    const tableHeader = [{
      id: 'nome',
      label: 'Nome',
    }, {
      id: 'vinculo',
      label: 'Vínculo',
      dataFormat: this.addVinculoLabel,
    }];
    if (['realizar-analise', 'cumprir-exigencia', 'consulta'].includes(this.props.acao)) {
      if (this.props.solicitante && this.props.solicitante.codigo === '01000') {
        tableHeader.push({
          id: 'numeroBeneficioPensao',
          label: 'Número do Benefício',
        });
      }
    } else if (['novo'].includes(this.props.acao)) {
      if (this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps',
        'gerenciar-negocio-dcomp'])) {
        tableHeader.push({
          id: 'numeroBeneficioPensao',
          label: 'Número do Benefício',
        });
      }
    }

    tableHeader.push({
      id: 'dataCessacao',
      label: 'Data de Cessação',
    });
    if (this.props.acao !== 'novo') {
      tableHeader.push({
        id: 'invalidezDeAcordoMedico',
        label: 'Resultado do Parecer Médico',
        dataFormat: this.formatResultadoPericia,
      });
    }
    tableHeader.push({
      id: 'acoes',
      label: null,
      dataFormat: this.createActionColumn,
    });
    return tableHeader;
  }

  options = {
    insertBtn: this.createCustomInsertButton,
    noDataText: 'Nenhum dependente foi adicionado à lista',
  };

  /**
   * Adiciona dependente a lista
   */
  addDependente = (dependente, edit) => {
    const { dependentes } = { ...this.props };
    if (edit) {
      dependentes[this.state.cell] = { ...dependente };
    } else {
      dependentes.push(dependente);
    }
    this.alteraListaDependentes(dependentes, null);
  }

  /**
   * Altera um dependente da lista
   */
  editDependente = (indice, dependenteSelecionado) => {
    const exigenciasDependenteSelecionado = [];
    let errosDependenteSelecionado = null;
    if (this.props.exigencias && !this.props.isFetchExigencias) {
      this.props.exigencias.forEach((exigencia) => {
        if (exigencia.codigoDependente === dependenteSelecionado.codigo) {
          exigenciasDependenteSelecionado.push(exigencia);
        }
      });
    }
    if (this.state.exigenciasDependentes) {
      this.state.exigenciasDependentes.forEach((exigencia) => {
        if (exigencia.codigoDependente === dependenteSelecionado.codigo) {
          exigenciasDependenteSelecionado.push(exigencia);
        }
      });
    }
    if (this.props.errosDependentes) {
      errosDependenteSelecionado = this.props.errosDependentes
        .filter(erro => erro.indiceLista === indice);
    }
    this.setState({
      cell: indice,
      dependenteSelecionado,
      exigenciasDependenteSelecionado,
      errosDependenteSelecionado,
    }, this.handleModal);
  }

  /**
   * Exclui um dependente da lista
   */
  deleteDependente = (row, dependenteSelecionado) => {
    const { dependentes } = { ...this.props };
    let errosDependente = null;
    if (this.props.errosDependentes) {
      errosDependente = this.props.errosDependentes
        .filter(erro => (erro.indiceLista !== row));
    }
    this.props.exigencias.forEach((exigencia) => {
      if (exigencia.codigoDependente === dependenteSelecionado.codigo && (exigencia.tipo === 12 || exigencia.tipo === 13 ||
        exigencia.tipo === 14 || exigencia.tipo === 15 || exigencia.tipo === 16 ||
        exigencia.tipo === 17)) {
        // eslint-disable-next-line
        exigencia.atendida = 1;
      }
    });
    dependentes.splice(row, 1);
    this.alteraListaDependentes(dependentes, errosDependente);
  }

  alteraListaDependentes = (listaDependentes, errosDependente) => {
    if (errosDependente) {
      this.props.validacaoErrosDependentes(errosDependente, true);
    }
    this.props.handleChange({ value: listaDependentes, isValid: listaDependentes.length > 0 });
  }

  /**
   * Verifica se dependente original do requerimento
   */
  verificarSeDependenteVeioDoRequest = () => (
    this.state.dependenteSelecionado ?
      this.state.dependenteSelecionado.codigo !== null
    && this.state.dependenteSelecionado.codigo !== undefined : false
  )

  /**
   * Remove a selecao do dependente
   */
  resetDependenteSelecionado = () => {
    this.setState({
      dependenteSelecionado: null,
      acaoModal: null,
      errosDependenteSelecionado: null,
    });
  }

  // Formata indicador da pericia realizada
  formatResultadoPericia = (invalidezDeAcordoMedico) => {
    if (invalidezDeAcordoMedico === true) {
      return 'Inválido';
    }
    if (invalidezDeAcordoMedico === false) {
      return 'Válido';
    }
    return '';
  }

  render() {
    const listaDependentesIndexada = this.props.dependentes.map((item, i) => {
      const itemIndexado = item;
      itemIndexado.acoes = i;
      return itemIndexado;
    });

    const modalDependente = this.state.showModal ?
      (<Dependente
        acaoModal={this.state.acaoModal}
        acao={this.props.acao}
        addDependente={this.addDependente}
        dependente={this.state.dependenteSelecionado}
        errosDependente={this.state.errosDependenteSelecionado}
        exigencias={this.state.exigenciasDependenteSelecionado}
        validacaoErrosDependentes={this.props.validacaoErrosDependentes}
        validacaoExigenciaDependente={this.validacaoExigenciaDependente}
        onHide={this.handleModal}
        resetDependente={this.resetDependenteSelecionado}
        showModal
      />
      ) : null;
    return (
      <DataGrid title="Dependentes" icon="ico-users" >
        <Table
          bordered
          data={listaDependentesIndexada}
          insertRow={this.props.estadoFormulario !== 'criado' &&
            ['novo', 'cumprir-exigencia', 'indeferidos'].includes(this.props.acao)}
          options={this.options}
          listaTableHeader={this.montaDependentesTableHeader()}
        />
        {modalDependente}
      </DataGrid>
    );
  }
}

Dependentes.propTypes = {
  acao: PropTypes.string.isRequired,
  dependentes: PropTypes.arrayOf({
    codigo: PropTypes.number,
    cpfDependente: PropTypes.string,
    nome: PropTypes.string,
    nomeMae: PropTypes.string,
    dataNascimento: PropTypes.date,
    sexo: PropTypes.number,
    estadoCivil: PropTypes.number,
    vinculo: PropTypes.number,
    capacidade: PropTypes.number,
    motivoInclusao: PropTypes.number,
    invalidezDeAcordoMedico: PropTypes.number,
    numeroBeneficioPensao: PropTypes.number,
    dataCessacao: PropTypes.number,
  }).isRequired,
  estadoFormulario: PropTypes.string.isRequired,
  solicitante: PropTypes.objectOf(PropTypes.object).isRequired,
  exigencias: PropTypes.arrayOf({
    codigo: PropTypes.number,
    acao: PropTypes.string,
    comentario: PropTypes.string,
    atributo: PropTypes.string,
    tipoDocumento: PropTypes.number,
    codigoDependente: PropTypes.number,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  errosDependentes: PropTypes.arrayOf(PropTypes.object).isRequired,
  validacaoErrosDependentes: PropTypes.func.isRequired,
  isFetchExigencias: PropTypes.bool.isRequired,
  checkIsFetchExigencias: PropTypes.func.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default Dependentes;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Pensao/Dependentes.jsx